/**
 *  实现功能
 *  1、默认情况下只禁止空格输入
 *  2、限制只能输入整数
 *  3、限制只能输入整数和小数（价格类）
 *  4、限制最大值和最小值(抛出错误给回调函数)
 */
const addListener = function(el, type, fn) {
  el.addEventListener(type, fn, false)
}
const spaceFilter = function(el) {
  addListener(el, 'keyup', () => {
    el.value = el.value.replace(/\s+/g, '')
  })
}
const intFilter = function(el) {
  addListener(el, 'keyup', () => {
    el.value = el.value.replace(/\D/g, '')
  })
}
const priceFilter = function(el) {
  addListener(el, 'keyup', () => {
    el.value = el.value.replace(/[^\d.]*/g, '')
    if (isNaN(el.value)) {
      el.value = ''
    }
  })
}
const specialFilter = function(el) {
  addListener(el, 'keyup', () => {
    el.value = el.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, '')
  })
}
export default {
  bind(el, binding) {
    if (el.tagName.toLowerCase() !== 'input') {
      el = el.getElementsByTagName('input')[0]
    }
    spaceFilter(el)
    switch (binding.arg) {
      case 'int':
        intFilter(el)
        break
      case 'price':
        priceFilter(el)
        break
      case 'special':
        specialFilter(el)
        break
      default:
        break
    }
  }
  // componentUpdated(el, binding, vnode) {
  //   if (el.tagName.toLowerCase() !== 'input') {
  //     el = el.getElementsByTagName('input')[0]
  //   }
  //   console.log(el)
  //   console.log(binding)
  //   console.log(vnode)
  //   spaceFilter(el)
  //   switch (binding.arg) {
  //     case 'int':
  //       intFilter(el)
  //       break
  //     case 'price':
  //       priceFilter(el)
  //       break
  //     case 'special':
  //       specialFilter(el)
  //       break
  //     default:
  //       break
  //   }
  // }
}
